import React from "react";

import { FidelityFormApi } from "../useFidelityForm";
import FidelityAuresKonnectWrapper from "../FidelityFranchise/FidelityAuresKonnectWrapper";

type Props = {
    form: FidelityFormApi;
    isFidelityNumberInValid: boolean;
    setIsEdited: (v: boolean) => void;
};

export default function AuresKonnectSection({
    form,
    isFidelityNumberInValid,
    setIsEdited,
}: Props) {
    const { values, flags, errors, setValue, setFlag, setError } = form;

    return (
        <FidelityAuresKonnectWrapper
            numberFidelityPoints={values.numberFidelityPoints}
            setNumberFidelityPoints={(v: string) =>
                setValue("numberFidelityPoints", v)
            }
            moneyCorrespondence={values.moneyCorrespondence}
            setMoneyCorrespondence={(v: string) =>
                setValue("moneyCorrespondence", v)
            }
            sortedVisibility={values.sortedVisibility}
            setSortedVisibility={(v: SaleModeVisibility[]) => setValue("sortedVisibility", v)}
            auresKonnectGroup={values.auresKonnectGroup}
            setAuresKonnectGroup={(v: string) =>
                setValue("auresKonnectGroup", v)
            }
            inputGroup={errors.group}
            setInputGroup={(v: boolean) => setError("group", v)}
            isCentralizationActive={flags.isCentralizationActive}
            setIsCentralizationActive={(v: boolean) =>
                setFlag("isCentralizationActive", v)
            }
            isVisibiliteActive={flags.isVisibiliteActive}
            setIsVisibiliteActive={(v: boolean) =>
                setFlag("isVisibiliteActive", v)
            }
            setChoiceFidelity={(v: string) => setValue("choiceFidelity", v)}
            choiceFidelity={values.choiceFidelity}
            designation={values.designation}
            setDesignation={(v: string) => setValue("designation", v)}
            isFidelityNumberInValid={isFidelityNumberInValid}
            inputNumberFidelityPoints={errors.numberFidelityPoints}
            setInputNumberFidelityPoints={(v: boolean) =>
                setError("numberFidelityPoints", v)
            }
            isTest={true}
            setIsEdited={setIsEdited}
        />
    );
}
